import { connect } from "react-redux";
import { InputNumber } from "antd";
import PropTypes from "prop-types";

import Resources from "scripts/resources";

const Component = ({
	currency,
	disabled,
	id,
	max,
	min = 0,
	value,
	onChange,
}) => {
	const options = {
		addonAfter: currency,
		disabled,
		formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
		id,
		min,
		onChange,
		parser: (value) => value.replace(/\$\s?|(,*)/g, ""),
		value,
	};

	if (max) options.max = max;

	return <InputNumber className="sp-input-currency" {...options} />;
};

Component.propTypes = {
	disabled: PropTypes.any,
	id: PropTypes.any,
	max: PropTypes.number,
	min: PropTypes.number,
	value: PropTypes.any,
	onChange: PropTypes.func,
};

export default connect((state) => {
	return {
		currency: state.settings.currency,
	};
})(Component);
